// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".propertyClusters{position:relative}", "",{"version":3,"sources":["/home/jenkins/agent/workspace/dashboard_gsa/src/views/auth/adminTools/orgManagement/property/PropertyClusters.vue"],"names":[],"mappings":"AAuBA,kBACE,iBAAA","file":"PropertyClusters.vue","sourcesContent":["@import \"@/styles/_variables.scss\";\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.propertyClusters {\n  position: relative;\n}\n"]}]);
// Exports
module.exports = exports;
